export default "__VITE_ASSET__BvG2lTNM__"